module.exports = __webpack_public_path__ + "901da5695f27f980d809f0f8d4646193.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/protherm@2x.png
 ** module id = 193
 ** module chunks = 0
 **/